import { Instance as TinyColor } from 'tinycolor2'
import { makeStyles } from 'tss-react/mui'
import { darkBg } from '../../../assets/colors'

const useStyles = makeStyles()((theme) => ({
    root: {
        color: '#007bff',
        width: 20,
        padding: '5px 0',
        height: 'calc(100% - 18px)',
        margin: '4px 0',

        '& .MuiSlider-thumb': {
            height: 10,
            width: 26,
            boxShadow: 'none',
            borderRadius: "2px",
            overflow: 'hidden',
            background: 'none',
            border: `2px solid ${theme.palette.mode === "dark" ? '#fff': darkBg}`,

            '&:focus, &:hover, &.Mui-active': {
                boxShadow: 'none',
            },
        },
        '& .MuiSlider-valueLabel': {
            fontSize: 12,
            fontWeight: 'normal',
            top: -6,
            backgroundColor: 'unset',
            color: theme.palette.text.primary,
            '&::before': {
                display: 'none',
            },
            '& *': {
                background: 'transparent',
                color: '#000',
            },
        },
        '& .MuiSlider-track': {
            border: 'none',
            height: 10,
            background: 'none',
            borderRadius: "2px"
        },
        '& .MuiSlider-rail': {
            opacity: 1,
            background: `linear-gradient(180deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)`,
            top: '-5px',
            bottom: '-5px',
            height: 'unset',
            borderRadius: "2px"
        }
    }
}))

export default useStyles